import {CancellationService} from '../../services/cancellation.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface CancellationReason {
  id: number;
  description: string;
  refers_to: any;
}

interface CancelAction {
  id: number;
  description: string;
}

@Component({
  templateUrl: './cancellation-order-dialog.component.html'
})
export class CancellationOrderDialogComponent implements OnInit {
  mode: number; // 0 = full return order | 1 = return order | 2 = full loading order | 3 = loading order
  title: string;
  id: number;
  serialNumber: string;
  commandId: number;
  reasons: CancellationReason[] = [];
  selectedReason: CancellationReason;
  orderDetails: any;
  actions: CancelAction[] = [];
  selectedAction: CancelAction;
  requestsCount: number;
  isLoading: boolean;

  // id: this.orderDetails.order_id,
  // orderId: this.orderDetails.order_id1,
  // requestTypeId: this.orderDetails.request_type_id,
  // orderTypeId: this.orderDetails.order_type_id, // 1 paraggelia | 2 aitisi
  // details: this.details,
  constructor(private cancellationService: CancellationService,
              private matDialogRef: MatDialogRef<CancellationOrderDialogComponent>,
              private router: Router,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.mode = +data.mode;
    this.title = data.title ? data.title : 'Ακύρωση εντολής';
    this.id = +data.id;
    this.isLoading = false;

    if (data.mode === 1) {
      this.serialNumber = data.serial_number;
      this.commandId = data.command_id;
    }
    if (data.mode === 2) {
      this.orderDetails = data.orderDetails;
      if (data.orderDetails.orderTypeId === 2) {
        this.requestsCount = data.orderDetails.requestsCount;
      }
    }

    if (data.mode === 3) {
      this.orderDetails = data.orderDetails;
    }
  }

  public async ngOnInit(): Promise<any> {
    try {
      if (this.mode === 0) {
        this.reasons = await this.cancellationService.getCancelReasons('refers_to=3');
      }

      if (this.mode === 1) {
        this.reasons = await this.cancellationService.getCancelReasons('refers_to=4');
      }

      if (this.mode === 2) {
        this.reasons = await this.cancellationService.getCancelReasons('refers_to=1');

        if (this.orderDetails.orderTypeId === 2) {
          const result = await this.cancellationService.getCancelActions();
          for (const action of result) {
            if (this.requestsCount > 1) {
              if (action.id !== 1) {
                this.actions.push(action);
              }
            } else {
              this.actions.push(action);
            }
          }
        }
      }

      if (this.mode === 3) {
        this.reasons = await this.cancellationService.getCancelReasons('refers_to=2');
        this.actions = await this.cancellationService.getCancelActions('(id=2 OR id=3)');
      }

    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τις αιτίες ακύρωσης');
    }
  }

  close(value?: boolean) {
    this.matDialogRef.close(value);
  }

  async modeCancelReturnOrder() {
    const model = {
      cancel_reason_id: this.selectedReason.id
    };
    await this.cancellationService.cancelReturnOrder(this.id, model);
    await this.router.navigate(['returns']);
    this.close(true);
  }

  async modeCancelReturnDetail() {
    const model = {
      command_id: this.commandId,
      serial_number: this.serialNumber,
      cancel_reason_id: this.selectedReason.id
    };
    await this.cancellationService.cancelReturnDetailsOrder(this.id, model);
    await this.router.navigate(['returns']);
    this.close(true);
  }

  async modeCancelLoadingOrder1() {
    const model = {
      cancel_reason_id: this.selectedReason.id,
      command_id: this.id,
      request_type_id: this.data.orderDetails.requestTypeId ? this.data.orderDetails.requestTypeId : null
    };
    await this.cancellationService.cancelLoadingOrder(model);
    await this.router.navigate(['loading_orders']);
    this.close(true);
  }

  async modeCancelLoadingOrder2() {
    const model = {
      cancel_reason_id: this.selectedReason.id,
      command_id: this.id,
      request_result_id: this.selectedAction.id,
      request_type_id: this.data.orderDetails.requestTypeId ? this.data.orderDetails.requestTypeId : null
    };
    await this.cancellationService.cancelLoadingOrder(model);
    await this.router.navigate(['loading_orders']);
    this.close(true);
  }

  async modeCancelLoadingOrder3() {
    const model = {
      cancel_reason_id: this.selectedReason.id,
      command_id: this.orderDetails.commandId,
      loading_command_serial_number_details_id: this.orderDetails.loading_command_serial_number_details_id
    };

    await this.cancellationService.cancelLoadingSerialOrder(model);
    await this.router.navigate(['loading_orders']);
    this.close(true);
  }

  async modeCancelLoadingSerialOrder() {
    const model = {
      cancel_reason_id: this.selectedReason.id,
      command_id: this.orderDetails.commandId,
      request_result_id: this.selectedAction.id,
      loading_command_serial_number_details_id: this.orderDetails.loading_command_serial_number_details_id
    };

    await this.cancellationService.cancelLoadingSerialOrder(model);
    await this.router.navigate(['loading_orders']);
    this.close(true);
  }

  async cancel() {
    try {
      this.isLoading = true;
      if (this.mode === 0) {
        await this.modeCancelReturnOrder();
      }

      if (this.mode === 1) {
        await this.modeCancelReturnDetail();
      }

      if (this.mode === 2 && this.orderDetails.orderTypeId === 1) {
        await this.modeCancelLoadingOrder1();
      }

      if (this.mode === 2 && this.orderDetails.orderTypeId === 2) {
        await this.modeCancelLoadingOrder2();
      }

      if (this.mode === 3 && this.orderDetails.orderTypeId === 1) {
        await this.modeCancelLoadingOrder3();
      }

      if (this.mode === 3 && this.orderDetails.orderTypeId === 2) {
        await this.modeCancelLoadingSerialOrder();
      }


    } catch (e) {
      this.isLoading = false;
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ακυρώσουμε την εντολή');
    }
  }


  //#region helper methods
  isButtonDisabled() {
    if (this.mode === 0 || this.mode === 1 || ((this.mode === 2 || this.mode === 3) && this.orderDetails.orderTypeId === 1)) {
      return !this.selectedReason;
    }

    if ((this.mode === 2 || this.mode === 3) && this.orderDetails.orderTypeId === 2) {
      return !(this.selectedReason && this.selectedAction);
    }
  }

  cancelDisplayButton() {
    if (this.mode === 0 ||
      this.mode === 1 ||
      (this.mode === 3 && this.orderDetails.orderTypeId === 1) ||
      (this.mode === 2 && this.orderDetails.orderTypeId === 1)) {
      return true;
    } else {
      return false;
    }
  }

  cancelDisplayButton2() {
    if ((this.mode === 2 &&
        this.orderDetails.orderTypeId === 2) ||
      (this.mode === 3 && this.orderDetails.orderTypeId === 2)) {
      return true;
    } else {
      return false;
    }
  }

  //#endregion
}
